import { I18nLabel } from 'api/api.types';

type UrlType = 'poll' | 'poll_day';

interface Element {
  id: string;
  frontend_id?: string;
  date?: string;
  polling_day_frontend_id?: string;
  short_title?: I18nLabel;
}

export const getInternalUrl = (element: Element, type: UrlType) => {
  if (type === 'poll_day') {
    if (!element.frontend_id) {
      return `/${element.id}`;
    }
    return `/${element.id}/${element.frontend_id}`;
  }

  let urlSuffix = element.frontend_id;

  if (!urlSuffix) {
    urlSuffix = element.short_title?.de
      ?.replace(/[\s/]/g, '-')
      .replace(/[^a-zA-ZäöüÄÖÜ0-9-]/g, '');
  }
  if (!urlSuffix) {
    urlSuffix = element.id;
  }

  const parentId = element.polling_day_frontend_id || element.date?.replaceAll('-', '');

  // prevent duplicate date in url for archive data
  const id = element.id?.toString().replace(parentId, 'a');

  return `/${parentId}/${id}/${urlSuffix}`;
};

export const getPollIdFromUrlParams = (id: string, parentDate: string) => {
  if (id.match(/a\d{1,2}/)) {
    return id.replace('a', parentDate);
  }
  return id;
};
